import React from 'react';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';

// InfoBlocks
import {
  InfoSection,
  FeatureList,
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';


const SleepShelter = () => {

  const features = [
    {
      title: '운전자 휴식 안전성 강화',
      bullets: [
      {
        label: (
          <>햇빛·비·강풍 등 외부 환경으로부터 운전자를 보호</>
        ),
      },
      {
        label: (
          <>편안한 휴식을 제공해 졸음운전 위험 감소</>
        ),
      },
      {
        label: (
          <>장시간 운전으로 인한 피로를 효과적으로 완화</>
        ),
      },
      ]
    },
    {
      title: '쾌적한 휴식 환경 제공',
      bullets: [
      {
        label: (
          <>그늘 및 비가림 공간 확보로 이용 편의성 향상</>
        ),
      },
      {
        label: (
          <>주변 시설과 조화를 이루는 안정적인 구조 및 디자인</>
        ),
      },
      {
        label: (
          <>자연 채광과 통풍을 고려한 설계로 쾌적한 사용자 경험 제공</>
        ),
      },
      ]
    },
    {
      title: '뛰어난 내구성과 안전성',
      bullets: [
      {
        label: (
          <>기상 변화와 외부 충격에도 견딜 수 있는 고내구성 자재 사용</>
        ),
      },
      {
        label: (
          <>구조 안전기준을 충족한 설계로 장기간 안정적으로 사용 가능</>
        ),
      },
      {
        label: (
          <>방수·방풍 기능 강화로 다양한 기후 조건에서 성능 유지</>
        ),
      },
      ]
    },
    {
      title: '현장 여건에 맞춘 맞춤형 설계',
      bullets: [
      {
        label: (
          <>설치 공간·이용량·지형 등에 따라 다양한 구조 선택 가능</>
        ),
      },
      {
        label: (
          <>유지보수 접근성을 고려한 설계로 관리 효율성 향상</>
        ),
      },
      {
        label: (
          <>주변 기반시설과의 간섭을 최소화한 시공 방식 제공</>
        ),
      },
      ]
    },
  ];

  

  return (
    <>
      <HeroSection
        title={`졸음쉼터 차양시설`}
        subtitle={`다양한 실시간 정보를 전달하여 \n고속도로 흐름을 안정화시킵니다`}
        backgroundImage="/images/products/facilities/sleep-shelter5.webp"
        breadcrumbs={[
          { label: '홈', path: '/' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '졸음쉼터 차양시설' },
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`고속도로 운전자의 쾌적한 휴식을 위한`}
        title={`졸음쉼터 차양시설`}
        description={
          <>
            고속도로 졸음운전 예방을 위해 조성된 졸음쉼터에 <strong>필수적으로 설치되는 기본 편의시설</strong>로, {' '}
            운전자가 안전하고 편안하게 휴식할 수 있도록 돕는 보호 구조물입니다.
            <br />
            <br />
            본 시설은 햇빛·비·눈 등 외부 환경으로부터 사용자를 효과적으로 보호하여 <strong>쾌적한 휴식 공간을 제공</strong>하며, {' '}
            이를 통해 졸음운전으로 인한 사고를 줄이고 고속도로 안전성을 한층 강화하는 역할을 수행합니다.

          </>
        }
        images={[
          '/images/products/facilities/sleep-shelter2.webp',
          '/images/products/facilities/sleep-shelter3.jpg',
          '/images/products/facilities/sleep-shelter4.jpg',
          '/images/products/facilities/sleep-shelter5.jpg',
          '/images/products/facilities/sleep-shelter6.webp',

        ]}
      />

      <SectionDivider />

      <InfoSection title="제품 특징">
        <FeatureList features={features} />
      </InfoSection>

      <ProductDetailNav
        category="facilities"
        currentPath="/products/facilities/sleep-shelter"
        listPath="/products/facilities"
      />


      <CTASection />
    </>
  );
};

export default SleepShelter;
